import React from "react";

import { IconLockOutlined } from "~/components/icon";
import { cx } from "~/tools/class-variance";
import type { Record } from "~/tools/record";

import { Popover } from "../../popover/Popover";
import { type ChartSize, LARGE_CHART_HEIGHT, MEDIUM_CHART_HEIGHT, SMALL_CHART_HEIGHT } from "../_utils";

import lockedDataImage from "./locked-data.svg";

const LOCKED_CHART_OPTIONS = {
	sm: {
		height: SMALL_CHART_HEIGHT,
		offset: [-20, 8],
		iconWrapperClass: cx("size-4"),
		iconClass: cx("text-10"),
	},
	md: {
		height: MEDIUM_CHART_HEIGHT,
		offset: [-24, 16],
		iconWrapperClass: cx("size-8"),
		iconClass: cx("text-base"),
	},
	lg: {
		height: LARGE_CHART_HEIGHT,
		offset: [-58, 30],
		iconWrapperClass: cx("size-24"),
		iconClass: cx("text-4xl"),
	},
} satisfies Record<ChartSize>;

export interface LockedChartProps {
	popoverContent: React.ReactNode;
	size: ChartSize;
}

export const LockedChart: React.FC<LockedChartProps> = ({ popoverContent, size }) => {
	const chartOptions = LOCKED_CHART_OPTIONS[size];

	return (
		<div
			className="flex h-full w-full items-center justify-center rounded-lg bg-[#F5F8FF] bg-left bg-repeat-x"
			data-testid="locked-chart"
			style={{
				backgroundImage: `url(${lockedDataImage})`,
				height: chartOptions.height,
			}}
		>
			<Popover
				align={{ targetOffset: chartOptions.offset }}
				content={popoverContent}
				destroyTooltipOnHide
				placement="bottomLeft"
				trigger="hover"
			>
				<div className={cx("flex items-center justify-center rounded-full bg-white/80", chartOptions.iconWrapperClass)}>
					<IconLockOutlined className={cx("text-gray-500", chartOptions.iconClass)} />
				</div>
			</Popover>
		</div>
	);
};
